const variables: { [key: string]: { [key: string]: string } } = {
  production: {
    REACT_APP_FACEBOOK_APP_ID: "314137701935699",
    REACT_APP_KONNEKTOR_URL: "https://mrapi.cheerz.com/api",
    REACT_APP_PROCESSOUT_API_KEY: "proj_v87WeMsSAYpECQcPLPHLKaCbIMsUiW5a",
  },
  staging: {
    REACT_APP_FACEBOOK_APP_ID: "1140031892679605",
    REACT_APP_KONNEKTOR_URL: "https://staging1.konnektor.io/api",
    REACT_APP_PROCESSOUT_API_KEY: "test-proj_v87WeMsSAYpECQcPLPHLKaCbIMsUiW5a",
  },
  test: {
    REACT_APP_FACEBOOK_APP_ID: "1140031892679605",
  },
};

export const getVariableByEnv = (variableName: string): string => {
  const releaseStage = document.querySelector<HTMLMetaElement>(`meta[name=cheerz-env]`);
  const varByEnv =
    releaseStage &&
    releaseStage.content &&
    variables[releaseStage.content] &&
    variables[releaseStage.content][variableName];

  const returnVar = varByEnv || process.env[variableName];
  if (!returnVar) {
    throw new Error(`Missing env ${variableName}`);
  }

  return returnVar;
};
